

















































































































































































































































































































































































/** @format */
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

import { dictServiceTypeMap, makeInvoiceTypeMap } from '@/types/system-management/dictionaries';
import {
  getInvoiceAllListAPI,
  getInvoiceEditInfoAPI,
  getParkInvoiceDetailAPI,
  invoiceRelationParkAPI
} from '@/api/setting-management';

@Component({
  components: {
    OrganizationSearch: () => import('@/components/organization-search/index.vue')
  }
})
export default class InvoiceBindPark extends Vue {
  // form布局
  private formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 5 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 19 }
    }
  };

  // 开票服务商
  private serviceTypeList: any = dictServiceTypeMap;

  // 开票项目
  private typeList: any = makeInvoiceTypeMap;

  private title: string = '添加开票企业';

  private form: any = null;

  // 表单需要的参数
  private formParams: any = {
    pkInvoiceId: '', // 开票企业ID
    drawer: '', //	开票人
    checker: '', //复核人
    payee: '', //收款人
    thirdParkCode: '', //三方车场编码
    thirdParkSecret: '', //车场秘钥
    switchList: [],
    enabled01: true,
    enabled02: false,
    enabled00: false
  };

  // 编辑表单
  private editInfo: any = {
    ...this.formParams
  };

  // 详情数据项
  private invoiceSettingFields: any[] = [
    {
      prop: 'serviceType',
      label: '开票服务商:'
    },
    {
      prop: 'organName',
      label: '所属机构:'
    },
    {
      prop: 'companyName',
      label: '企业名称:'
    },
    {
      prop: 'saleCode',
      label: '纳税识别号:'
    },
    {
      prop: 'platformTerminalCode',
      label: '终端代码:'
    },
    {
      prop: 'addressNoAndPhone',
      label: '地址、电话:'
    },
    {
      prop: 'saleBankNo',
      label: '开户行与账户:'
    }
  ];

  // 开票企业信息
  private invoiceSettingListData: any[] = [];

  // 编辑详情数据
  private detailData: any = {};
  private isDisabled: boolean = true;
  spining: boolean = false;
  // 机构ID
  @Prop({ type: String, default: '' })
  organizationId!: string;

  // 车场ID
  @Prop({ type: String, default: '' })
  parkId!: string;

  // 监听visible
  @Watch('parkId', { immediate: true })
  onChangeParkId() {
    this.initData();
  }

  //新的详情
  detailDatanew: any = {};
  // 编辑，提交，表单验证
  handleEditSubmit(e: any) {
    e.stopPropagation();
    e.preventDefault();
    this.form.validateFields(async (err: boolean, values: any) => {
      if (!err) {
        const {
          checker,
          content,
          drawer,
          payee,
          taxClassifyCode,
          enabled,
          taxRate,
          thirdParkCode,
          thirdParkSecret
        } = values;
        const switchList: any[] = [];
        if (!content) return this.$message.error('请先选择开票企业！');
        Object.keys(content).map(item => {
          var obj: any = {};
          if (content[item]) {
            obj.content = content[item];
          } else {
            obj.content = '';
          }
          if (taxClassifyCode[item]) {
            obj.taxClassifyCode = taxClassifyCode[item];
          } else {
            obj.taxClassifyCode = '';
          }
          if (taxRate[item]) {
            obj.taxRate = taxRate[item];
          } else {
            obj.taxRate = '';
          }
          obj.enabled = enabled[item] ? '01' : '00';
          obj.type = item;
          switchList.push(obj);
        });
        const update = {
          switchList,
          checker,
          drawer,
          payee,
          thirdParkCode,
          thirdParkSecret
        };
        this.editData(update);
      } else {
        console.log('报错');
      }
    });
  }

  // 重置数据
  async handleResetData() {
    await this.initData();
  }

  // 开票企业信息选择
  handleChangeInvoice(value: string) {
    if (value) {
      this.getInvoiceEditInfoData(value);
    } else {
      this.detailDatanew = {};
      this.detailData = {};
    }
  }

  // 编辑－请求数据
  async editData(update: any) {
    try {
      if (this.spining) return;
      this.spining = true;
      const { pkInvoiceId: pkInvoiceId } = this.editInfo;
      if (pkInvoiceId) {
        const { parkId } = this;
        // invoiceRelationParkAPI
        const { status, msg } = await invoiceRelationParkAPI({
          parkId,
          pkInvoiceId,
          ...update
        });
        if (status === '9999') {
          this.$message.success('绑定成功');
          this.isDisabled = true;
          // this.$emit('create', {})
          // this.form.resetFields()
        } else {
          this.$message.error(msg || '绑定失败！');
        }
      } else {
        this.$message.error('请先选择开票企业！');
      }
    } catch (error) {
      // console.log(error)
      this.$message.error((error && error.msg) || '绑定失败！');
    } finally {
      this.spining = false;
    }
  }

  // 开票企业下拉选择-获取详情数据
  async getInvoiceEditInfoData(pkInvoiceId: string) {
    const self = this;
    try {
      //getInvoiceEditInfoAPI
      const { status, code, msg, data } = await getInvoiceEditInfoAPI({
        pkInvoiceId: pkInvoiceId
      });
      if (status === '9999') {
        if (data) {
          const detailInfo: any = {};
          Object.keys(data).map(item => {
            if (item === 'serviceType') {
              detailInfo[item] =
                self.$store.state.dictionaries.allDictionaries['cp_base_invoice_service_type'][data[item]];
              this.isHuYou = detailInfo[item] == '沪友';
            } else {
              detailInfo[item] = data[item];
            }
          });
          this.detailDatanew = detailInfo;
          //地址+电话
          this.detailDatanew.addressNoAndPhone = `${detailInfo.companyAddress || ''} ${detailInfo.mobile || ''}`;
          //开户行+账号
          this.detailDatanew.saleBankNo = `${detailInfo.bankName || ''} ${detailInfo.bankAccountNo || ''} `;

          this.detailData = detailInfo;
        }
      } else {
        this.$message.error(msg || '获取详情失败！');
      }
    } catch (e) {
      this.$message.error((e && e.msg) || '获取详情失败！');
    }
  }
  isHuYou = false;
  // 根据车场获取当前开票企业详情
  async getParkInvoiceDetailData() {
    const self = this;
    try {
      const { parkId } = this;
      const { status, msg, data } = await getParkInvoiceDetailAPI({
        parkId
      });
      if (status === '9999' && data.pkInvoiceId) {
        this.getInvoiceEditInfoData(data.pkInvoiceId);

        if (data) {
          const detailInfo: any = {};
          Object.keys(data).map(item => {
            if (item === 'serviceType') {
              detailInfo[item] =
                self.$store.state.dictionaries.allDictionaries['cp_base_invoice_service_type'][data[item]];
              this.isHuYou = detailInfo[item] == '沪友';
            } else {
              detailInfo[item] = data[item];
            }
          });
          this.detailData = detailInfo;
          this.detailDatanew = detailInfo;
          //地址+电话
          this.detailDatanew.addressNoAndPhone = `${detailInfo.companyAddress || ''} ${detailInfo.mobile || ''}`;
          //开户行+账号
          this.detailDatanew.saleBankNo = `${detailInfo.bankName || ''} ${detailInfo.bankAccountNo || ''} `;
          console.log(detailInfo.bankAccountNo);
        } else {
          this.detailData = {};
          this.detailDatanew = {};
        }
      } else {
        this.detailData = {};
        this.detailDatanew = {};
        // this.$message.error('获取详情失败！');
      }
    } catch (e) {
      this.$message.error((e && e.msg) || '获取详情失败！');
    }
  }

  // 获取下拉列表数据
  async getInvoiceSettingAllListData() {
    try {
      const { organizationId } = this;
      //getInvoiceAllListAPI
      const { status, msg, data = {} } = await getInvoiceAllListAPI({
        organId: organizationId
      });
      if (status === '9999') {
        const { datas } = data;
        const resultData = datas.map((item: any) => {
          const organName = item.organName || '';
          const companyName = item.companyName ? `-${item.companyName}` : '';
          const typeName = item.type ? `-${this.typeList[item.type]}` : '';
          const taxRate = item.taxRate ? `-${item.taxRate}%` : '';
          return {
            label: `${organName}${companyName}${typeName}${taxRate}`,
            value: item.pkInvoiceId
          };
        });
        // this.invoiceSettingListData = [...[{ label: '请选择', value: '' }], ...resultData]
        this.invoiceSettingListData = [...resultData];
      } else {
        this.$message.error(msg || '获取列表失败！');
      }
    } catch (e) {
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
    }
  }

  // 重置编辑表单
  async resetEditData(detailData: any) {
    const { formParams } = this;
    this.editInfo = {
      ...formParams
    };
    if (detailData) {
      // 修改
      Object.keys(formParams).forEach(item => {
        if (typeof detailData[item] !== 'undefined') this.editInfo[item] = detailData[item];
      });
    }
    this.editInfo.enabled00 = this.getFormInitialValue('00', 'enabled');
    this.editInfo.enabled01 = this.getFormInitialValue('01', 'enabled');
    this.editInfo.enabled02 = this.getFormInitialValue('02', 'enabled');
    this.form = this.$form.createForm(this, {});
  }

  // 初始化数据
  async initData() {
    const { parkId } = this;
    this.isDisabled = true;
    this.getInvoiceSettingAllListData();
    if (parkId) {
      // 根据ID-判断是否编辑
      await this.getParkInvoiceDetailData();
    }
    await this.resetEditData(this.detailData);
  }

  // 生命周期初始化
  async created() {
    // await this.initData()
  }

  activated() {
    this.initData();
  }

  // 验证税率
  validateTaxRate(rule: any, value: any, callback: any) {
    const isFloatNumber: any = /^(-?\d+)(\.\d+)?$/;
    if (value && (!isFloatNumber.test(value) || value <= 0 || value >= 100)) {
      callback('请输入0到100之间到数字！');
    } else {
      callback();
    }
  }
  getFormInitialValue(type: string, key: string) {
    const { switchList } = this.editInfo;
    if (switchList.length === 0) {
      if (type === '00' && key === 'enabled') {
        return true;
      } else {
        return;
      }
    }
    const right = switchList.filter((item: any) => {
      return item.type == type;
    })[0];
    if (key === 'enabled') {
      return right[key] === '00' ? false : true;
    }
    return right[key];
  }
}
